import { Dispatch, SetStateAction, useState } from 'react'
import { AutoComplete } from 'primereact/autocomplete'
import { DropdownChangeParams } from 'primereact/dropdown'
import { Button } from 'primereact/button'
import { useTranslation } from 'react-i18next'

// local imports
import './SearchBox.scss'
import locationMyOffice from 'assets/icons/location.svg'
import locationCommon from 'assets/icons/location-shared.svg'
import LocationService from 'service/LocationService'
import { IAllLocationList } from 'types/LocationType'
import { AutoCompleteWrapper } from '../styled'

interface ITracingSearchProps {
  selectedLocation: IAllLocationList | undefined
  setSelectedLocation: Dispatch<SetStateAction<IAllLocationList | undefined>>
}

export default function MapSearchBox(props: ITracingSearchProps) {
  const { selectedLocation, setSelectedLocation } = props
  const { t } = useTranslation()
  /* Form Input States */
  const [inputText, setInputText] = useState('')
  const [filteredLocation, setFilteredLocation] = useState<any>([])

  /* Search on input change */
  const searchLocation = (event: { query: string }) => {
    setTimeout(() => {
      if (!event.query.trim().length) {
        return
      } else {
        LocationService.FindLocation(event.query)
          .then((res) => setFilteredLocation(res.data))
          .catch((error) => console.log(error))
      }
    }, 250)
  }

  const handleInputChange = (e: DropdownChangeParams) => setInputText(e.value)
  const handleSelectLocation = (e: DropdownChangeParams) => setSelectedLocation(e.value)
  const handleClearLocation = () => {
    setSelectedLocation(undefined)
    setInputText('')
  }

  const setItemIcon = (isMyFirm: boolean) => {
    if (!isMyFirm) return locationCommon
    else return locationMyOffice
  }

  /* Search box templates */
  const selectedItemTemplate = (item: any) => {
    return item.Name + ' | ' + item.firmName
  }

  const itemTemplate = (item: any) => {
    return (
      <div className="d-flex align-items-center">
        <img src={setItemIcon(item.IsMyFirmLocation)} className="ms-2 me-3 of-location-img" alt="location" />
        <div className="map-firm-info py-2">
          <div className="map-location-name">{item.Name}</div>
          {/* <div className="map-firm-district-name">CountryName | CityName | {`${item.DistrictName}`}</div> */}
          <div className="map-firm-firm-name">{item.firmName}</div>
          <div className="map-firm-address">{item.Address}</div>
        </div>
      </div>
    )
  }

  /* Constants - Variables */
  const hasLocationSelected = typeof selectedLocation === 'object' && selectedLocation !== null

  return (
    <AutoCompleteWrapper>
      <div className="map-search-autocomplete">
        <span className="p-input-icon-right w-100">
          <AutoComplete
            inputClassName="mapSearchInput"
            panelClassName="mapSearchPanel"
            field="Name"
            value={selectedLocation ?? inputText}
            suggestions={filteredLocation}
            completeMethod={searchLocation}
            itemTemplate={itemTemplate}
            selectedItemTemplate={selectedItemTemplate}
            readOnly={hasLocationSelected}
            onSelect={handleSelectLocation}
            onChange={handleInputChange}
            placeholder={t('input-texts.map-search-box')}
          />

          {hasLocationSelected ? (
            <Button
              icon="pi pi-times"
              className="p-button-rounded p-button-text p-button-plain"
              style={{ position: 'absolute', right: '4px', top: '6px' }}
              onClick={handleClearLocation}
            />
          ) : (
            <i className="pi pi-search" style={{ color: '#45BFE5', fontSize: '20px', zIndex: 3 }} />
          )}
        </span>
      </div>
    </AutoCompleteWrapper>
  )
}
